import React from "react";
import { ASSETS_URL } from '../components/Store.js';
import { Link } from "react-router-dom";
import { useLanguage } from "../hooks/use-language.js";
import { useTranslationsById } from "../hooks/use-translations-by-id.js";

/**
 * Componente para mostrar un libro de una colección.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.clase - Clase adicional para el contenedor del libro.
 * @param {Object} props.item - Datos del libro.
 * @param {boolean} props.swiper - Indica si se está utilizando con Swiper.
 * @returns {JSX.Element} Elemento JSX que representa el libro de la colección.
 */
const LibroColeccion = props => {

  const { clase, item, swiper } = props;
  const lang = useLanguage();
  const texts = useTranslationsById({ mainSectionName: "portada_libro", language: lang });

  const title =
    item?.title ||
    item?.titulo ||
    item?.name ||
    item?.nombre ||
    'Libro';

  const estado = (() => {
    if (item.gratis === '1') return 'Gratis';
    if (item.interactivo === '1') return 'Interactivo';
    if (item.sonido === '1') return 'Con audio';
    return '';
  })();

  return (
    <div className={`cover-book ${clase ? clase : 'col-6 col-lg-4 mb-4'}`}>
      <Link to={item.link} className={"focusable-secondary"} aria-label={`${texts?.getText({ id:"details", defaultText:"Ver detalles del libro"})} ${title}${estado ? `. ${estado}` : ''}`}>
        <div className="cover-book-wrapper">
          {(() => {
            if (swiper) {
              return (<img alt={`${texts?.getText({id:"book_cover", defaultText: "Portada del libro"})} '${title}'`} className="swiper-lazy img-fluid" data-src={`${ASSETS_URL}${item.portada}`} />)
            } else {
              return (<img alt={`${texts?.getText({id:"book_cover", defaultText: "Portada del libro"})} '${title}'`} className="img-fluid" src={`${ASSETS_URL}${item.portada}`} />)
            }
          })()}
          {(() => {
            if (item.gratis === '1') {
              return <img className="additionalIcon" src="/img/freeIcon.png" alt="" aria-hidden={true} />
            } else if (item.gratis === '0' && item.interactivo === '1') {
              return <img className="additionalIcon" src="/img/inticon.png" alt="" aria-hidden={true} />
            } else if (item.gratis === '0' && item.interactivo === '0' && item.sonido === '1') {
              return <i className="additionalIcon" src="/img/soundIcon.png" alt="" aria-hidden={true} />
            }
          })()}

        </div>
        {(() => {
          if (swiper) {
            return (<div className="swiper-lazy-preloader"></div>)
          }
        })()}
      </Link>
    </div>
  )
}

export default LibroColeccion;